/** Used by profile page to highlight AND open incoming shared bets in Quickbet */
export const IncomingBetOpenPostIdSearchParam = 'postId'

/** Used by profile page to highlight bets when clicking "View" in toast */
export const IncomingBetViewPostIdSearchParam = 'viewPostId'
